(function() {
    angular
        .module("wzModule")
        .controller("WzSEConfigurationController", WzSEConfigurationController)

        WzSEConfigurationController.$inject = [
            "$rootScope",
            "$scope",
            "$stateParams",
            "wzService",
            "userMessagingService",
            "$uibModal"
        ]

    function WzSEConfigurationController(
        $rootScope,
        $scope,
        $stateParams,
        wzService,
        userMessagingService,
        $uibModal
    ){
        "use strict"

        $rootScope.title = "Work Zone Configuration | WANCO"

        $scope.editWz     = false

        const resetWzUpdate = () => {
            $scope.wzUpdate = {
                id:                 $scope.wz.id,
                timezone:           $scope.wz.timezone,
                posted_speed_limit: $scope.wz.posted_speed_limit,
                direction:          $scope.wz.direction,
                vehicle_impact:     $scope.wz.vehicle_impact,
                road_name:          $scope.wz.road_name
            }
        }

        $scope.cancelWzEdit = () => {
            $scope.editWz = false
            resetWzUpdate()
        }

        $scope.changeSpeedLimit = () => {
            if ($scope.wzUpdate.posted_speed_limit < 1) {
                $scope.wzUpdate.posted_speed_limit = 0
            } else if ($scope.wzUpdate.posted_speed_limit > 255) {
                $scope.wzUpdate.posted_speed_limit = 255
            }
        }

        $scope.updateWz = () => {

            if ($scope.editWzForm.$valid) {

                $scope.submitted = true

                const success = (data) => {
                    $scope.editWz = false
                    $scope.applyWzData(data)
                }

                const failure = (error) => {
                    $scope.cancelWzEdit()
                    userMessagingService.error(error)
                }

                wzService.update($scope.wzUpdate, success, failure)

            }
        }

        const sortByDisplayPosition = () => {
            $scope.wzDevices.sort((a, b) => { return a.display_position > b.display_position ? 1 : -1 })
        }

        const adjustDisplayPositions = () => {

            const newDisplayPositions = []

            for (const device of $scope.wzDevices) {
                newDisplayPositions.push({
                    wz_device_id:         device.wz_device_id,
                    new_display_position: device.display_position
                })
            }

            const success = (data) => {
                if (data) {
                    $scope.applyWzData(data)
                }
                $scope.disableAdjustDisplayPositions = false
            }

            const failure = (error) => {
                console.error(error)
                $scope.disableAdjustDisplayPositions = false
            }

            wzService.adjustDisplayPositions($stateParams.wz_id, newDisplayPositions, success, failure)

            setTimeout(() => {
                $scope.disableAdjustDisplayPositions = false
            }, 150)
        }

        $scope.moveDisplayPositionUp = (device) => {

            if (device.display_position <= 1) { return }

            $scope.disableAdjustDisplayPositions = true

            // Move Up = Numeric Down

            const otherDevice = $scope.wzDevices[device.display_position - 2]
            otherDevice.display_position = otherDevice.display_position + 1
            device.display_position      = device.display_position - 1

            sortByDisplayPosition()
            adjustDisplayPositions()

        }

        $scope.moveDisplayPositionDown = (device) => {

            if (device.display_position >= $scope.wzDevices.length) { return }

            // Move Down = Numeric Up

            const otherDevice = $scope.wzDevices[device.display_position]
            otherDevice.display_position = otherDevice.display_position - 1
            device.display_position      = device.display_position + 1

            sortByDisplayPosition()
            adjustDisplayPositions()

        }

        $scope.addDevice = (deviceID) => {

            const success = (data) => {
                $scope.applyWzData(data)
            }

            const failure = (error) => {
                console.error(error)
            }

            wzService.addDevice($stateParams.wz_id, deviceID, success, failure)

        }

        $scope.removeDevice = function(device) {
            console.log(device)
            $scope.removeDeviceFromWZ(device.device_id)

        }

        $scope.$watch("wz", () => {
            if ($scope.wz && $scope.wz.hasOwnProperty("id") && $scope.wz.type === "SE") {
                resetWzUpdate()
            }
        })

    }
})()
